/* @flow */

import React from 'react';
import { Table, Icon, Header } from 'semantic-ui-react';

type Props = {
  deployment: CatalogDeployment,
};

const displayDate = deployment => {
  const date = deployment.deployedAt.format('DD/MM/YYYY à HH:mm');
  if (deployment.inProduction) {
    return <Header as="h3">{date}</Header>;
  }

  return date;
};

const displayUser = user =>
  user && user.email ? user.email : 'Utilisateur supprimé';

const DeploymentItem = ({ deployment }: Props) => (
  <Table.Row>
    <Table.Cell>
      {deployment.inProduction && (
        <Icon name="heartbeat" size="large" color="red" circular />
      )}
    </Table.Cell>
    <Table.Cell textAlign="center">{displayDate(deployment)}</Table.Cell>
    <Table.Cell textAlign="center">
      {displayUser(deployment.deployedBy)}
    </Table.Cell>
  </Table.Row>
);

export default DeploymentItem;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Deployments/components/DeploymentItem.js